module.exports = __webpack_public_path__ + "img/filler_1.8e0c6e57.svg";